import { IdentityRepo } from '@core/repositories'
import store from '@/store'
const resource = `/session/preferences`
import Vue from "vue";
import {refreshToken,keycloakObj,mergeObjects } from '@core/config/utils'

export default {

    async get(config) {
        await refreshToken();
        let preferences = await Vue.prototype.$keycloak.loadUserProfile();
        if(preferences.attributes && preferences.attributes.preferences && preferences.attributes.preferences[0]){
            return JSON.parse(preferences.attributes.preferences[0])
        }
    },
      
    async update(data, config) {
        await refreshToken();
        let preferences = await  Vue.prototype.$keycloak.loadUserProfile();
        if(!preferences.attributes)
            preferences.attributes = {}
        if(!preferences.attributes.preferences)
            preferences.attributes.preferences = ["{}"]
        data = mergeObjects(JSON.parse(preferences.attributes.preferences[0]),data)
        preferences.attributes.preferences[0] = JSON.stringify(data) 
        const keysToRemove = ["userProfileMetadata", "phoneNumber", "id", "emailVerified", "companyName"];
        keysToRemove.forEach((key) => delete preferences[key]);
        const { baseURL } = keycloakObj()
        await refreshToken();
        return IdentityRepo.post("account", preferences, { baseURL,withCredentials: true });
    },
}